import { AboutUs } from '@/about/about-us';
import { AboutMedia } from '@/about/media';
import { AboutPartner } from '@/about/partner';

$(document).ready(function() {
    AboutUs.init();
    AboutMedia.init();
    AboutPartner.initFormValidation();
});